import { PropsWithChildren } from 'react';

import { RenderIf } from 'components/render-if/RenderIf';
import { AvailableFeatureFlags } from 'data/generated/graphql';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

interface BehindFeatureFlagProps {
  featureFlagName: AvailableFeatureFlags;
}

export const BehindFeatureFlag = ({ featureFlagName, children }: PropsWithChildren<BehindFeatureFlagProps>) => {
  const isEnabled = useFeatureFlag(featureFlagName);

  return <RenderIf condition={!!isEnabled}>{children}</RenderIf>;
};
